// src/components/ContactForm.js
import React, { useState } from "react";
import "./ContactForm.css";

const ContactForm = ({ onFormSubmit, setResult, formToken }) => {
    const handleSubmit = async (e) => {
        e.preventDefault();
        setResult("Sending....");

        const formData = new FormData(e.target);
        formData.append("access_key", formToken); // Append the Web3Forms token

        try {
            await onFormSubmit(formData, e);
            setResult("Form Submitted Successfully. Our representative will reach out.");
        } catch (error) {
            console.error("Submission error:", error);
            setResult("We could not submit your form, please contact us via phone call or WhatsApp.");
        }
    };

    return (
        <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input type="text" name="name" required />

            <label htmlFor="email">Email</label>
            <input type="email" name="email" required />

            <label htmlFor="PhoneNumber">Phone Number</label>
            <input type="tel" name="PhoneNumber" />

            <label htmlFor="message">Message</label>
            <textarea name="message" required></textarea>

            <button type="submit">Submit Form</button>
        </form>
    );
};

export default ContactForm;
